<template>
  <div class="row">
        <div class='col-xl-12 col-lg-12'>
            <div class="card card-stats mb-4 mb-xl-0" style="background-color:#57BB90">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h6 class="card-title text-uppercase text-muted mb-0 text-green-stronger">ÚLTIMO CRÉDITO</h6>
                    <span class="h4 font-weight-bold mb-0 text-white">{{objetoCabecalho != undefined && objetoCabecalho.valor != undefined ? objetoCabecalho.valor : 0 | formatMoney}}</span>
                  </div>
                  <div class="col-auto">
                    <button type="button" class="btn btn-outline-ultimo-credito" @click="$emit('view-dashboard-repasse', true)"><li class="oi oi-action-undo"></li> VOLTAR</button>
                  </div>
                </div>
                <p class="mt-3 mb-0 text-muted text-sm">
                  <span class="badge badge-mod-success">{{labelBadgeUltimoCredito}}</span>
                  <span class="text-nowrap text-green-stronger"></span>
                </p>
              </div>
            </div>
        </div>
        <div class='col-xl-12 col-lg-12'>
          <br/>
        </div>
        <div class='col-xl-12 col-lg-12'>
          <ul class="nav nav-tabs flex-column flex-sm-row">
            <li class="nav-item">
              <a class="nav-link" :class="tabSelecionado == 'repasse' ? 'active' : '' " href="#repasse" @click="tab('repasse');">Repasse</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="tabSelecionado == 'servicosRecebidos' ? 'active' : '' " href="#servicosRecebidos" @click="tab('servicosRecebidos');">Serviços Recebidos</a>
            </li>
          </ul>
        </div>
        
        <transition name="view">
        <div class='col-xl-12 col-lg-12' v-show="tabSelecionado == 'repasse'">
          <br/>
         <div class='col-xl-12 col-lg-12 table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl' v-show="listaLancamentos != undefined && listaLancamentos.length > 0">
            
            <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">Lançamentos</th>
                      <th scope="col">Proventos</th>
                      <th scope="col">Descontos</th>
                      <th scope="col">Recebidos</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(objeto) of listaLancamentos" v-bind:key="objeto.pk_repasse_calculado_sasc"  v-show="!objeto.desconto_nao_realizado">
                      <td class="text-left" :class="objeto.liquido ? 'font-weight-bold': ''">{{objeto.descricao_lancamento_repasse}} <a href="#convenio" @click="selectConvenioLancamentoRepasse(objeto.convenio, objeto.descricao_lancamento_repasse);"><span :class="objeto.convenio != '' ? 'badge badge-info': ''" >{{objeto.convenio != "" ? objeto.convenio : ''}}</span></a></td>
                      <td v-if="objeto.valor_credito > 0 && !objeto.liquido" :class="objeto.liquido ? 'font-weight-bold': ''">{{objeto.valor_credito | formatMoney}}</td>
                      <td v-else></td>
                      <td v-if="objeto.valor_debito > 0">{{objeto.valor_debito | formatMoney}}</td>
                      <td v-else></td>
                      <td v-if="objeto.valor_credito > 0 && objeto.liquido" :class="objeto.liquido ? 'font-weight-bold': ''">{{objeto.valor_credito | formatMoney}}</td>
                      <td v-else></td>
                    </tr>
                    <tr>
                      <td scope="col" colspan="4">
                        <hr/>
                      </td>
                    </tr>
                    <tr>
                      <td scope="col" class="text-left font-weight-bold">
                        Total
                      </td>
                      <td scope="col" class="font-weight-bold">
                        {{totalProventos | formatMoney}}
                      </td>
                      <td scope="col" class="font-weight-bold">
                        {{totalDescontos | formatMoney}}
                      </td>
                      <td scope="col" class="font-weight-bold">
                        {{totalRecebidos | formatMoney}}
                      </td>
                    </tr>
                  </tbody>
                </table>
          </div>
          <div class='col-xl-12 col-lg-12 table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl' v-show="listaLancamentos != undefined && listaLancamentos.length > 0 && totalDevidoSaldoDevedor > 0">
            
            <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col" colspan="4">Desconto Não Realizado por Insuficiência de Saldo</th>
                    </tr>
                    <tr>
                      <th scope="col">Lançamentos</th>
                      <th scope="col">Devido</th>
                      <th scope="col">Descontado</th>
                      <th scope="col">Saldo Devedor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(objeto) of listaLancamentos" v-bind:key="objeto.pk_repasse_calculado_sasc" v-show="objeto.desconto_nao_realizado">
                      <td class="text-left" >{{objeto.descricao_lancamento_repasse}}</td>
                      <td v-if="objeto.valor_devido > 0" >{{objeto.valor_devido | formatMoney}}</td>
                      <td v-else></td>
                      <td v-if="objeto.valor_descontado > 0">{{objeto.valor_descontado | formatMoney}}</td>
                      <td v-else></td>
                      <td v-if="objeto.saldo_devedor > 0" >{{objeto.saldo_devedor | formatMoney}}</td>
                      <td v-else></td>
                    </tr>
                    <tr>
                      <td scope="col" colspan="4">
                        <hr/>
                      </td>
                    </tr>
                    <tr>
                      <td scope="col" class="text-left font-weight-bold">
                        Total
                      </td>
                      <td scope="col" class="font-weight-bold">
                        {{totalDevidoSaldoDevedor | formatMoney}}
                      </td>
                      <td scope="col" class="font-weight-bold">
                        {{totalDescontadoSaldoDevedor | formatMoney}}
                      </td>
                      <td scope="col" class="font-weight-bold">
                        {{totalSaldoDevedor | formatMoney}}
                      </td>
                    </tr>
                  </tbody>
                </table>
          </div>
          
          
          <div class='col-xl-12 col-lg-12 table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl' v-show="listaLancamentos != undefined && listaLancamentos.length > 0">
            <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col" colspan="4">Total Mensal</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    <tr>
                      <td class="font-weight-bold" colspan="2">Imposto de Renda</td>
                      <td class="font-weight-bold" colspan="2">Outros Valores</td>
                    </tr>
                    
                    <tr>
                      <td class="text-left">Base Bruta</td>
                      <td class="text-left">{{totalMensal != undefined && totalMensal.base_bruta_ir != undefined ? totalMensal.base_bruta_ir : 0 | formatMoney}}</td>
                      <td class="text-left">Total de Créditos</td>
                      <td class="text-left">{{totalMensal != undefined && totalMensal.valor_total_credito != undefined ? totalMensal.valor_total_credito : 0  | formatMoney}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">Desconto de Dependente</td>
                      <td class="text-left">{{totalMensal != undefined && totalMensal.valor_dependente_ir != undefined ? totalMensal.valor_dependente_ir : 0  | formatMoney}}</td>
                      <td class="text-left">Total de Descontos</td>
                      <td class="text-left">{{totalMensal != undefined && totalMensal.valor_total_debito != undefined ? totalMensal.valor_total_debito : 0  | formatMoney}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">Base Líquida</td>
                      <td class="text-left">{{totalMensal != undefined && totalMensal.base_liquida_ir != undefined ? totalMensal.base_liquida_ir : 0  | formatMoney}}</td>
                      <td class="text-left">Total Recebido</td>
                      <td class="text-left">{{totalMensal != undefined && totalMensal.valor_total_recebido != undefined ? totalMensal.valor_total_recebido : 0  | formatMoney}}</td>
                    </tr>
                    <tr>
                      <td class="text-left">Valor Imposto de Renda</td>
                      <td class="text-left">{{totalMensal != undefined && totalMensal.valor_ir != undefined ? totalMensal.valor_ir : 0  | formatMoney}}</td>
                      <td class="text-left">Total Demonstrativo</td>
                      <td class="text-left">{{totalMensal != undefined && totalMensal.valor_total_demonstrativo != undefined ? totalMensal.valor_total_demonstrativo : 0  | formatMoney}}</td>
                    </tr>
                  </tbody>
                </table>
          </div>
        </div>
        </transition>
        <transition name="view">
        <div class='col-xl-12 col-lg-12' v-show="tabSelecionado == 'servicosRecebidos'">
          <br/>
          <div class='col-xl-12 col-lg-12 table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl' v-show="listaServicosRecebidosAtendimento != undefined && listaServicosRecebidosAtendimento.length > 0">
            
            <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">Ano</th>
                      <th scope="col">Atendimento</th>
                      <th scope="col">Hospital</th>
                      <th scope="col">Convênio</th>
                      <th scope="col">Acomodação</th>
                      <th scope="col">Paciente</th>
                      <th scope="col">Procedimento</th>
                      <th scope="col">Realização</th>
                      <th scope="col">Lançamento de Repasse</th>
                      <th scope="col">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    <tr>
                      <td><input class="form-control form-control-sm" v-model="filterList.ano"/></td>
                      <td><input class="form-control form-control-sm" v-model="filterList.atendimento"/></td>
                      <td><input class="form-control form-control-sm" v-model="filterList.hospital"/></td>
                      <td><input class="form-control form-control-sm" v-model="filterList.convenio"/></td>
                      <td><input class="form-control form-control-sm" v-model="filterList.acomodacao"/></td>
                      <td><input class="form-control form-control-sm" v-model="filterList.paciente"/></td>
                      <td><input class="form-control form-control-sm" v-model="filterList.procedimento"/></td>
                      <td><input class="form-control form-control-sm" v-model="filterList.realizacao" v-mask="'##/##/####'"/></td>
                      <td><input class="form-control form-control-sm" v-model="filterList.lancamento"/></td>
                      <td><money class="form-control form-control-sm" v-model.lazy="filterList.valor"/></td>
                    </tr>
                    <tr v-for="objeto in filteredServicosRecebidosAtendimento" v-bind:key="objeto.pk_repasse_lancamento_sasc">
                      <td>{{objeto.ano_atendimento}}</td>
                      <td>{{objeto.atendimento}}</td>
                      <td>{{objeto.hospital}}</td>
                      <td>{{objeto.convenio}}</td>
                      <td>{{objeto.acomodacao}}</td>
                      <td>{{objeto.paciente}}</td>
                      <td>{{objeto.codigo_procedimento}}</td>
                      <td>{{objeto.data_realizacao | formatDate}}</td>
                      <td>{{objeto.descricao_lancamento_repasse}}</td><td>{{objeto.debito ? objeto.valor_lancamento * -1 : objeto.valor_lancamento | formatMoney}} <span :class="objeto.debito ? 'badge badge-pill badge-warning' : 'badge badge-pill badge-success'">{{objeto.debito ? 'D' : 'C'}}</span></td>
                    </tr>
                    <tr>
                      <td scope="col" colspan="10">
                        <hr/>
                      </td>
                    </tr>
                    <tr>
                      <td scope="col" class="text-left font-weight-bold">
                        Total Atendimento
                      </td>
                      <td scope="col" class="font-weight-bold text-right" colspan="9">
                        {{totalServicosRecebidoAtendimento | formatMoney}}
                      </td>
                    </tr>
                  </tbody>
                </table>
          </div>
          
          
          <div class='col-xl-12 col-lg-12 table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl' v-show="listaServicosRecebidosLancamentoEventual != undefined && listaServicosRecebidosLancamentoEventual.length > 0">
            <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">Nº Lançamento</th>
                      <th scope="col">Data</th>
                      <th scope="col">Descrição Lançamento Eventual</th>
                      <th scope="col">Lançamento de Repasse</th>
                      <th scope="col">Convênio</th>
                      <th scope="col">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(objeto) of listaServicosRecebidosLancamentoEventual" v-bind:key="objeto.pk_repasse_lancamento_sasc" >
                      <td>{{objeto.numero_lancamento}}</td>
                      <td>{{objeto.data_lancamento | formatDate}}</td>
                      <td>{{objeto.descricao_lancamento_eventual}}</td>
                      <td>{{objeto.descricao_lancamento_repasse}}</td>
                      <td>{{objeto.convenio}}</td>
                      <td>{{objeto.debito ? objeto.valor_lancamento * -1 : objeto.valor_lancamento | formatMoney}} <span :class="objeto.debito ? 'badge badge-pill badge-danger' : 'badge badge-pill badge-success'">{{objeto.debito ? 'D' : 'C'}}</span></td>
                    </tr>
                    <tr>
                      <td scope="col" colspan="10">
                        <hr/>
                      </td>
                    </tr>
                    <tr>
                      <td scope="col" class="text-left font-weight-bold">
                        Total Lançamento
                      </td>
                      <td scope="col" class="font-weight-bold text-right" colspan="9">
                        {{totalServicosRecebidoLancamentoEventual | formatMoney}}
                      </td>
                    </tr>
                  </tbody>
                </table>
          </div>
          <div class='col-xl-12 col-lg-12 table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl' v-show="listaServicosRecebidosLancamentoEventual != undefined && listaServicosRecebidosLancamentoEventual.length > 0 && listaServicosRecebidosAtendimento != undefined && listaServicosRecebidosAtendimento.length > 0">
                <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed">
                  <tbody>
                    <tr>
                      <td scope="col" colspan="2">
                        <hr/>
                      </td>
                    </tr>
                    <tr>
                      <td scope="col" class="text-left font-weight-bold">
                        Total Geral
                      </td>
                      <td scope="col" class="font-weight-bold text-right" colspan="2">
                        {{totalServicosRecebidoAtendimento + totalServicosRecebidoLancamentoEventual | formatMoney}}
                      </td>
                    </tr>
                  </tbody>
                </table>
          </div>
        </div>
        </transition>
  </div>
</template>

<script>
import http from "./../../../../axios";
import moment from 'moment'
import { mask } from "vue-the-mask";
moment.locale('pt-BR');
export default {
  name: "DemonstrativoRepasseUltimoRepasseDetalhado",
  props: ['objetoCabecalho'],
  directives: { mask },
  created: function() {
    this.init();
  },
  updated: function(){
    if(this.objetoCabecalho != undefined && this.objetoCabecalho.pk_repasse_sasc != undefined && this.repasseAnterior != this.objetoCabecalho.pk_repasse_sasc){
      this.getRepasseCooperado();
    }
  },
  methods: {
    init: function() {
      this.getTokens();
    },
    getTokens: function() {
      this.tokens = this.$cooperadowebapi.tokens.get("usuario");
    },
    
    tab: function(selecionado){
      this.tabSelecionado = selecionado;
      if(this.tabSelecionado == "servicosRecebidos"){
        if(this.repasseAnteriorServicosRecebidos != this.objetoCabecalho.pk_repasse_sasc){
          this.getServicosRecebidosRepasseCooperado();
        }
       }else{
        this.cleanFilter();
      }
    },
    cleanFilter: function(){
      this.filterList.ano = "";
      this.filterList.atendimento= "";
      this.filterList.hospital= "";
      this.filterList.convenio= "";
      this.filterList.acomodacao= "";
      this.filterList.paciente= "";
      this.filterList.procedimento= "";
      this.filterList.realizacao= "";
      this.filterList.lancamento= "";
      this.filterList.valor= "";
    },
    selectConvenioLancamentoRepasse: function(convenio, lancamentoRepasse){
      this.filterList.convenio = convenio;
      this.filterList.lancamento = lancamentoRepasse;
      this.tab("servicosRecebidos")
    },
   getRepasseCooperado: function() {
      this.totalProventos = 0;
      this.totalDescontos = 0;
      this.totalRecebidos = 0;
      
      this.totalDevidoSaldoDevedor = 0;
      this.totalDescontadoSaldoDevedor = 0;
      this.totalSaldoDevedor = 0;
      this.$Progress.start();
      http
        .get(`api/repasse/${this.objetoCabecalho.pk_repasse_sasc}/cooperado/${this.tokens.id}/lancamentos/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            this.listaLancamentos = r.data.result.listaLancamentos;
            this.totalMensal = r.data.result.totalMensal[0];
            this.repasseAnterior = this.objetoCabecalho.pk_repasse_sasc;

            if(this.listaLancamentos != undefined && this.listaLancamentos.length > 0){
              for(var i=0; i < this.listaLancamentos.length; i++){
                this.totalProventos = this.listaLancamentos[i].valor_credito > 0 && !this.listaLancamentos[i].liquido ? this.totalProventos + this.listaLancamentos[i].valor_credito : this.totalProventos;
                this.totalDescontos = this.listaLancamentos[i].valor_debito > 0 ? this.totalDescontos + this.listaLancamentos[i].valor_debito : this.totalDescontos;
                this.totalRecebidos = this.listaLancamentos[i].valor_credito > 0 && this.listaLancamentos[i].liquido ? this.totalRecebidos + this.listaLancamentos[i].valor_credito : this.totalRecebidos;

                this.totalDevidoSaldoDevedor = this.listaLancamentos[i].valor_devido > 0 && this.listaLancamentos[i].desconto_nao_realizado ? this.totalDevidoSaldoDevedor + this.listaLancamentos[i].valor_devido : this.totalDevidoSaldoDevedor;
                this.totalDescontadoSaldoDevedor = this.listaLancamentos[i].valor_descontado > 0 && this.listaLancamentos[i].desconto_nao_realizado ? this.totalDescontadoSaldoDevedor + this.listaLancamentos[i].valor_descontado : this.totalDescontadoSaldoDevedor;
                this.totalSaldoDevedor = this.listaLancamentos[i].saldo_devedor > 0 && this.listaLancamentos[i].desconto_nao_realizado ? this.totalSaldoDevedor + this.listaLancamentos[i].saldo_devedor : this.totalSaldoDevedor;

              }

            }else{
              this.totalProventos = 0;
              this.totalDescontos = 0;
              this.totalRecebidos = 0;
              
              this.totalDevidoSaldoDevedor = 0;
              this.totalDescontadoSaldoDevedor = 0;
              this.totalSaldoDevedor = 0;
            }
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
   getServicosRecebidosRepasseCooperado: function() {
      this.totalServicosRecebidoLancamentoEventual = 0;
      this.totalServicosRecebidoAtendimento = 0;
      this.$Progress.start();
      http
        .get(`/api/repasse/${this.objetoCabecalho.pk_repasse_sasc}/cooperado/${this.tokens.id}/servicosrecebidos/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {

            this.listaServicosRecebidosLancamentoEventual = [];
            this.listaServicosRecebidosAtendimento = [];
            this.repasseAnteriorServicosRecebidos = this.objetoCabecalho.pk_repasse_sasc;
            if(r.data.result != undefined && r.data.result.length > 0){
              for(var i=0; i < r.data.result.length; i++){
                if(r.data.result[i].descricao_lancamento_eventual != ""){
                  this.listaServicosRecebidosLancamentoEventual.push(r.data.result[i]);
                  this.totalServicosRecebidoLancamentoEventual = r.data.result[i].credito ? 
                                                                    this.totalServicosRecebidoLancamentoEventual + r.data.result[i].valor_lancamento : 
                                                                 r.data.result[i].debito ? 
                                                                    this.totalServicosRecebidoLancamentoEventual - r.data.result[i].valor_lancamento : 
                                                                 this.totalServicosRecebidoLancamentoEventual;
                }else{
                  this.listaServicosRecebidosAtendimento.push(r.data.result[i]);
                  this.totalServicosRecebidoAtendimento = r.data.result[i].credito ? 
                                                                    this.totalServicosRecebidoAtendimento + r.data.result[i].valor_lancamento : 
                                                                 r.data.result[i].debito ? 
                                                                    this.totalServicosRecebidoAtendimento - r.data.result[i].valor_lancamento : 
                                                                 this.totalServicosRecebidoAtendimento;
                }
              }

            }else{
              this.totalServicosRecebidoLancamentoEventual = 0;
              this.totalServicosRecebidoAtendimento = 0;
            }
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    }
  },
  computed: {
    labelBadgeUltimoCredito: function() {
      return this.objetoCabecalho != undefined && this.objetoCabecalho.entidade != undefined && this.objetoCabecalho.repasse != undefined
        ? `${this.objetoCabecalho.entidade} - Repasse ${this.objetoCabecalho.repasse} - ${Vue.filter("formatDate")(
            this.objetoCabecalho.competencia
          )}`
        : `Nenhum Repasse encontrado`;
    },
    filteredServicosRecebidosAtendimento:function() {
      const { filterList, listaServicosRecebidosAtendimento} = this

      var lista = this.listaServicosRecebidosAtendimento
        .filter(objeto => String(objeto.ano_atendimento).toLowerCase().indexOf(filterList.ano.toLowerCase()) > -1)
        .filter(objeto => objeto.atendimento.toLowerCase().indexOf(filterList.atendimento.toLowerCase()) > -1)
        .filter(objeto => objeto.hospital.toLowerCase().indexOf(filterList.hospital.toLowerCase()) > -1)
        .filter(objeto => objeto.convenio.toLowerCase().indexOf(filterList.convenio.toLowerCase()) > -1)
        .filter(objeto => objeto.acomodacao.toLowerCase().indexOf(filterList.acomodacao.toLowerCase()) > -1)
        .filter(objeto => objeto.paciente.toLowerCase().indexOf(filterList.paciente.toLowerCase()) > -1)
        .filter(objeto => objeto.codigo_procedimento.toLowerCase().indexOf(filterList.procedimento.toLowerCase()) > -1)
        .filter(objeto => Vue.filter("formatDate")(objeto.data_realizacao).toLowerCase().indexOf(filterList.realizacao.toLowerCase()) > -1)
        .filter(objeto => objeto.descricao_lancamento_repasse.toLowerCase().indexOf(filterList.lancamento.toLowerCase()) > -1)
        .filter(objeto => filterList.valor == 0 || (filterList.valor > 0 && objeto.valor_lancamento == filterList.valor));

        this.totalServicosRecebidoAtendimento = 0;

        for(var i=0; i < lista.length; i++){
            this.totalServicosRecebidoAtendimento = lista[i].credito ? 
                                                              this.totalServicosRecebidoAtendimento + lista[i].valor_lancamento : 
                                                            lista[i].debito ? 
                                                              this.totalServicosRecebidoAtendimento - lista[i].valor_lancamento : 
                                                            this.totalServicosRecebidoAtendimento;
        }

      return lista;
    },
  },
  data: function() {
    return {
      filterList: {
        ano: "",
        atendimento: "",
        hospital: "",
        convenio: "",
        acomodacao: "",
        paciente: "",
        procedimento: "",
        realizacao: "",
        lancamento: "",
        valor: ""
      },
      listaLancamentos: undefined,
      listaServicosRecebidosAtendimento: [],
      listaServicosRecebidosLancamentoEventual: [],
      totalMensal: undefined,
      totalProventos: 0,
      totalDescontos: 0,
      totalRecebidos: 0,
      totalDevidoSaldoDevedor: 0,
      totalDescontadoSaldoDevedor: 0,
      totalSaldoDevedor: 0,
      totalServicosRecebidoAtendimento: 0,
      totalServicosRecebidoLancamentoEventual: 0,
      repasseAnterior: "",
      repasseAnteriorServicosRecebidos: "",
      tabSelecionado: "repasse",
      tokens: {},
      chartOptions: {
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },


          xaxis: {
            type: 'datetime',
            categories: ["2018-09-19T00:00:00", "2018-09-19T01:30:00", "2018-09-19T02:30:00",
              "2018-09-19T03:30:00", "2018-09-19T04:30:00", "2018-09-19T05:30:00",
              "2018-09-19T06:30:00"
            ],
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm'
            },

          }
        },

        series: [{
          name: 'series1',
          data: [31, 40, 28, 51, 42, 109, 100]
        }, {
          name: 'series2',
          data: [11, 32, 45, 32, 34, 52, 41]
        }],

        seriesDonut: [44, 55, 41, 17, 15],
        chartOptionsDonut: {
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        }
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/demonstrativo/repasse/DemonstrativoRepasseUltimoRepasseDetalhado.vue